import { defineMessages } from 'react-intl';

export const jsmPortalPlaygroundRovoChatMessages = defineMessages({
	chatLabel: {
		id: 'JsmPortalPlayground.rovoChat.chatLabel',
		defaultMessage: 'Beaconstone Support chat',
	},
	chatName: {
		id: 'JsmPortalPlayground.rovoChat.chatName',
		defaultMessage: 'Beaconstone Support',
	},
	showHistory: {
		id: 'JsmPortalPlayground.rovoChat.showHistory',
		defaultMessage: 'Show chat history',
	},
	newChat: {
		id: 'JsmPortalPlayground.rovoChat.newChat',
		defaultMessage: 'New chat',
	},
	saveChat: {
		id: 'JsmPortalPlayground.rovoChat.saveChat',
		defaultMessage: 'Save chat',
	},
	moreActions: {
		id: 'JsmPortalPlayground.rovoChat.moreActions',
		defaultMessage: 'More chat actions',
	},
	closeChat: {
		id: 'JsmPortalPlayground.rovoChat.closeChat',
		defaultMessage: 'Close chat',
	},
	visitorQuestion: {
		id: 'JsmPortalPlayground.rovoChat.visitorQuestion',
		defaultMessage: 'How do I setup VPN access for remote work?',
	},
	thinking: {
		id: 'JsmPortalPlayground.rovoChat.thinking',
		defaultMessage: 'Rovo is thinking',
	},
	answerIntro: {
		id: 'JsmPortalPlayground.rovoChat.answerIntro',
		defaultMessage: "Here's step-by-step instructions on how to setup Beaconstone VPN:",
	},
	answerStep1Heading: {
		id: 'JsmPortalPlayground.rovoChat.answerStep1Heading',
		defaultMessage: 'Step 1: Install VPN client',
	},
	answerStep1Before: {
		id: 'JsmPortalPlayground.rovoChat.answerStep1Before',
		defaultMessage: 'Download the approved VPN client from',
	},
	answerStep1Link: {
		id: 'JsmPortalPlayground.rovoChat.answerStep1Link',
		defaultMessage: 'VPN installer',
	},
	answerStep1After: {
		id: 'JsmPortalPlayground.rovoChat.answerStep1After',
		defaultMessage: 'then open the installer and follow the instructions',
	},
	answerStep2Heading: {
		id: 'JsmPortalPlayground.rovoChat.answerStep2Heading',
		defaultMessage: 'Step 2: Sign in with SSO',
	},
	answerStep2Bullet1: {
		id: 'JsmPortalPlayground.rovoChat.answerStep2Bullet1',
		defaultMessage: 'Open the VPN application and select "Sign-in"',
	},
	answerStep2Bullet2: {
		id: 'JsmPortalPlayground.rovoChat.answerStep2Bullet2',
		defaultMessage: 'Complete MFA verification with official credentials',
	},
	answerStep3Heading: {
		id: 'JsmPortalPlayground.rovoChat.answerStep3Heading',
		defaultMessage: 'Step 3: Connect',
	},
	answerStep3Bullet1: {
		id: 'JsmPortalPlayground.rovoChat.answerStep3Bullet1',
		defaultMessage: 'Select profile: Beaconstone-GB and click connect',
	},
	answerStep3Bullet2: {
		id: 'JsmPortalPlayground.rovoChat.answerStep3Bullet2',
		defaultMessage: 'Complete MFA verification with official credentials',
	},
	answerOutro: {
		id: 'JsmPortalPlayground.rovoChat.answerOutro',
		defaultMessage: 'You should now have secure remote access.',
	},
	passwordVisitorQuestion: {
		id: 'JsmPortalPlayground.rovoChat.password.visitorQuestion',
		defaultMessage: "I'm locked out of my account, how do I get back in?",
	},
	passwordAnswerIntro: {
		id: 'JsmPortalPlayground.rovoChat.password.answerIntro',
		defaultMessage: "Here's how to recover access and unlock your Beaconstone account:",
	},
	passwordAnswerStep1Heading: {
		id: 'JsmPortalPlayground.rovoChat.password.answerStep1Heading',
		defaultMessage: 'Step 1: Verify your identity',
	},
	passwordAnswerStep1Body: {
		id: 'JsmPortalPlayground.rovoChat.password.answerStep1Body',
		defaultMessage:
			'Open the account recovery portal from any browser and submit your company email address.',
	},
	passwordAnswerStep2Heading: {
		id: 'JsmPortalPlayground.rovoChat.password.answerStep2Heading',
		defaultMessage: 'Step 2: Confirm via secondary device',
	},
	passwordAnswerStep2Bullet1: {
		id: 'JsmPortalPlayground.rovoChat.password.answerStep2Bullet1',
		defaultMessage: 'Approve the push notification on your registered authenticator app',
	},
	passwordAnswerStep2Bullet2: {
		id: 'JsmPortalPlayground.rovoChat.password.answerStep2Bullet2',
		defaultMessage: 'Enter the 6-digit backup security code if prompted',
	},
	passwordAnswerStep3Heading: {
		id: 'JsmPortalPlayground.rovoChat.password.answerStep3Heading',
		defaultMessage: 'Step 3: Set a new password',
	},
	passwordAnswerStep3Bullet1: {
		id: 'JsmPortalPlayground.rovoChat.password.answerStep3Bullet1',
		defaultMessage: 'Choose a new password with at least 12 characters',
	},
	passwordAnswerOutro: {
		id: 'JsmPortalPlayground.rovoChat.password.answerOutro',
		defaultMessage: 'You should now be able to sign in across all workspace apps.',
	},
	laptopVisitorQuestion: {
		id: 'JsmPortalPlayground.rovoChat.laptop.visitorQuestion',
		defaultMessage: 'What do I need to do on my first day to get my laptop ready?',
	},
	laptopAnswerIntro: {
		id: 'JsmPortalPlayground.rovoChat.laptop.answerIntro',
		defaultMessage: "Here's a quick checklist to get your new work laptop up and running:",
	},
	laptopAnswerStep1Heading: {
		id: 'JsmPortalPlayground.rovoChat.laptop.answerStep1Heading',
		defaultMessage: 'Step 1: Complete initial sign-in',
	},
	laptopAnswerStep1Body: {
		id: 'JsmPortalPlayground.rovoChat.laptop.answerStep1Body',
		defaultMessage:
			'Power on your machine, connect to Wi-Fi, and sign in with your Beaconstone SSO credentials.',
	},
	laptopAnswerStep2Heading: {
		id: 'JsmPortalPlayground.rovoChat.laptop.answerStep2Heading',
		defaultMessage: 'Step 2: Install core workplace apps',
	},
	laptopAnswerStep2Bullet1: {
		id: 'JsmPortalPlayground.rovoChat.laptop.answerStep2Bullet1',
		defaultMessage: 'Open Company Portal to download Slack and Zoom',
	},
	laptopAnswerStep2Bullet2: {
		id: 'JsmPortalPlayground.rovoChat.laptop.answerStep2Bullet2',
		defaultMessage: "Sign in to Slack using your team's workspace domain",
	},
	laptopAnswerStep3Heading: {
		id: 'JsmPortalPlayground.rovoChat.laptop.answerStep3Heading',
		defaultMessage: 'Step 3: Enable device compliance',
	},
	laptopAnswerStep3Bullet1: {
		id: 'JsmPortalPlayground.rovoChat.laptop.answerStep3Bullet1',
		defaultMessage: 'Confirm disk encryption (FileVault / BitLocker) is active',
	},
	laptopAnswerOutro: {
		id: 'JsmPortalPlayground.rovoChat.laptop.answerOutro',
		defaultMessage: "You're now ready to collaborate with your team.",
	},
	sources: {
		id: 'JsmPortalPlayground.rovoChat.sources',
		defaultMessage: '2 Sources',
	},
	goodAnswer: {
		id: 'JsmPortalPlayground.rovoChat.goodAnswer',
		defaultMessage: 'Good answer',
	},
	badAnswer: {
		id: 'JsmPortalPlayground.rovoChat.badAnswer',
		defaultMessage: 'Bad answer',
	},
	giveFeedback: {
		id: 'JsmPortalPlayground.rovoChat.giveFeedback',
		defaultMessage: 'Give feedback',
	},
	askFollowUp: {
		id: 'JsmPortalPlayground.rovoChat.askFollowUp',
		defaultMessage: 'Ask a follow-up',
	},
	addContext: {
		id: 'JsmPortalPlayground.rovoChat.addContext',
		defaultMessage: 'Add context',
	},
	moreApps: {
		id: 'JsmPortalPlayground.rovoChat.moreApps',
		defaultMessage: '×5',
	},
	agentPicker: {
		id: 'JsmPortalPlayground.rovoChat.agentPicker',
		defaultMessage: 'Auto',
	},
	dictate: {
		id: 'JsmPortalPlayground.rovoChat.dictate',
		defaultMessage: 'Dictate',
	},
	disclosure: {
		id: 'JsmPortalPlayground.rovoChat.disclosure',
		defaultMessage: 'Uses AI. Verify results.',
	},
});
